import numeral from 'numeral';

import { NumberFormattingOptions } from './types';
import { getFormatString } from './utils';

export function getKNotationNumber(
  num: number,
  options: Pick<NumberFormattingOptions, 'decimals' | 'strict'> & { uppercase?: boolean } = {},
) {
  let { decimals, strict, uppercase = false } = options;
  let formatString = getFormatString({ decimals, strict, comma: false }) + 'a';
  const formattedNumber = numeral(num).format(formatString);
  return uppercase ? formattedNumber.toUpperCase() : formattedNumber;
}
